import { render, staticRenderFns } from "./subdivisions.vue?vue&type=template&id=f23c78ac&"
import script from "./subdivisions.vue?vue&type=script&lang=js&"
export * from "./subdivisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports